//polyfills
import "core-js/stable";
import "./polyfills/DOMCollection";
import "regenerator-runtime/runtime";
import "css/application.scss";
import "css/single-video-player.scss";
import find from "lodash/find";
import SingleVideoPlayer from "utils/SingleVideoPlayer";
import { offlineBuildStaticAssetDirectory } from "../constants";
// Player entry point

(() => {
  // We need to define `publicPath` in `webpack` so it knows where to reference other files. Our
  // javascript file lives on a cdn and is in a hashed path, so we can't determine this at build
  // time. See https://webpack.github.io/docs/configuration.html#output-publicpath on how to
  // define this at runtime (which is what we're doing here).

  if (window.offline) {
    // We'll be launching from `index.html` in the output directory so just make it relative.
    __webpack_public_path__ = `./${offlineBuildStaticAssetDirectory}/`;
  } else {
    // Find the script element in the DOM that points to the entry point. Use the `src`
    // attribute to determine where all the JavaScript files live. Set the webpack variable so
    // all subsequent chunked files have the correct URL.
    const testSourceRegex = /single-video-player(?:\.min)?\.js/;

    const elements = document.getElementsByTagName("script");
    const verseScriptElement = find(elements, (element) => {
      const src = element.getAttribute("src");
      const matches = testSourceRegex.test(src);
      return matches;
    });
    if (!verseScriptElement) return;
    const src = verseScriptElement.getAttribute("src");
    if (!src) return;
    const prefixMatch = src.match(/^(.*?\/dist\/)/);
    if (prefixMatch) {
      const prefix = prefixMatch[1];

      __webpack_public_path__ = prefix;
    }
  }
})();

window.SingleVideoPlayer = SingleVideoPlayer;
window.VersePlayer = SingleVideoPlayer;
